export class LocaleManager {
  formatDate(value: any, options: Intl.DateTimeFormatOptions, timeZone: string, lng?: string) {
    return Intl.DateTimeFormat(lng, { ...options, timeZone }).format(value);
  }

  formatCurrency(value: any, options: Intl.NumberFormatOptions, currency: string, lng?: string) {
    return this.formatNumber(value, { ...options, currency }, lng);
  }

  formatUnits(value: any, options: Intl.NumberFormatOptions, unit: string, lng?: string) {
    return this.formatNumber(value, { ...options, unit }, lng);
  }

  formatNumber(value: any, options: any, lng?: string) {
    return Intl.NumberFormat(lng, options).format(value);
  }
}
